import SiInviteButton from './components/web/SiInviteButton';
import { useSiInviteState } from './store';
const inviteSi = {
    key: 'invite-si',
    Content: SiInviteButton,
    group: 2
};
/**
 * The toolbar's "Invite an SI", only once the server has said this person may invite SIs in this meeting.
 *
 * @returns {Object | undefined}
 */
export function useSiInviteButton() {
    const { availability } = useSiInviteState();
    return availability === 'yes' ? inviteSi : undefined;
}
